var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrophy = function SvgTrophy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 24,
    height: 24,
    viewBox: "0 0 512 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M486.4 25.6h-76.8V0H102.4v25.6H25.6C10.24 25.6 0 35.84 0 51.2v61.44c0 58.88 43.52 107.52 102.4 115.2v2.56c0 74.24 51.2 135.68 120.32 151.04L204.8 435.2h-58.88c-10.24 0-20.48 7.68-23.04 17.92L102.4 512h307.2l-20.48-58.88c-2.56-10.24-12.8-17.92-23.04-17.92H307.2l-17.92-53.76c69.12-15.36 120.32-76.8 120.32-151.04v-2.56c58.88-7.68 102.4-56.32 102.4-115.2V51.2c0-15.36-10.24-25.6-25.6-25.6m-384 151.04c-28.16-7.68-51.2-33.28-51.2-64V76.8h51.2zM307.2 256 256 227.84 204.8 256l12.8-51.2-38.4-51.2h53.76L256 102.4l23.04 51.2h53.76l-38.4 51.2zm153.6-143.36c0 30.72-23.04 58.88-51.2 64V76.8h51.2z"
  })));
};
export default SvgTrophy;